import { useState } from "react";

const useForceUpdate = () => {
  const [_render, setRender] = useState(false);

  return () => setRender((render) => !render); // re render the component
};

export default useForceUpdate;
